export const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
